import Link from 'next/link'

export interface CtaButtonProps {
  text: string
  href: string
}

export const CtaButton = ({ text, href }: CtaButtonProps) => {
  return (
    <Link
      href={href}
      className='inline-block'
    >
      <button className='h-[40px] whitespace-nowrap rounded-xl bg-button-brand-primary-dark-rest px-5 text-sm font-medium text-white transition-colors duration-150 hover:bg-button-brand-primary-dark-hover active:bg-button-brand-primary-dark-pressed lg:h-[64px] lg:w-[224px] lg:px-6 lg:text-xl!'>
        {text}
      </button>
    </Link>
  )
}
